import { type JSX, type PropsWithChildren, useEffect, useState } from 'react'
import { Show } from '@/components/show'
import { cn } from '@/lib/utils'
import { TransferLoading } from '../transfer-loading'

interface StudentStepLoadingLayoutProps extends PropsWithChildren {
  loadingLabel: string[]
  isLoading: boolean
  className?: string
  loadingImage?: JSX.Element
}

export const StudentStepLoadingLayout = ({
  children,
  isLoading,
  loadingLabel,
  className,
  loadingImage
}: StudentStepLoadingLayoutProps) => {
  const [labelIndex, setLabelIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      const totalLabel = loadingLabel.length
      setLabelIndex((prev) => (prev + 1) % totalLabel)
    }, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <div
      className={cn(
        'w-full h-full flex items-center justify-center',
        className
      )}
    >
      <Show when={isLoading}>
        <TransferLoading
          image={loadingImage}
          loadingLabel={loadingLabel[labelIndex]}
        />
      </Show>
      <Show when={!isLoading}>{children}</Show>
    </div>
  )
}
